import filesaver from 'file-saver';
import Observer from '../../common/utils/observer';
import { generateLiveApiInstance } from '../../common/appId';
import _Symbol from '../common/symbolApi';
import TicksService from '../common/TicksService';

export let tmpApi;
export let symbolApi;
export let ticksService;

// Callable (matches binaryblocks: View.js calls `symbolPromise(this.api)`).
// tradingbots ignores the passed api — it builds its own skipV4 instance for
// symbol metadata and uses symbolApi.initPromise as a property, not a method.
export const symbolPromise = () =>
    new Promise(async resolve => {
        tmpApi = await generateLiveApiInstance({ skipV4: true });
        symbolApi = new _Symbol(tmpApi);
        ticksService = new TicksService(tmpApi);
        symbolApi.initPromise.then(() => {
            resolve();
        });
    });

export const createScope = async () => {
    const api = await generateLiveApiInstance();
    const observer = new Observer();
    return { observer, api, ticksService, symbolApi };
};

export const appendRow = (trade, state, isDesc = false) => ({
    id  : state.id + 1,
    rows: isDesc
        ? [
            {
                ...trade,
                id: state.id + 1,
            },
            ...state.rows,
        ]
        : [
            ...state.rows,
            {
                ...trade,
                id: state.id + 1,
            },
        ],
});

export const updateRow = (prevRowIndex, trade, state) => ({
    id  : state.id,
    rows: [
        ...state.rows.slice(0, prevRowIndex),
        {
            ...trade,
            id: state.id,
        },
    ],
});

export const saveAs = ({ data, filename, type }) => {
    const blob = new Blob([data], { type });
    filesaver.saveAs(blob, filename);
};

export const restrictInputCharacter = ({ whitelistRegEx, input }) => input.match(new RegExp(whitelistRegEx));
